
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { FloatingShapeComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { ScreenService } from '@catch/services';
import { TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import confetti from 'canvas-confetti';
import { map, Observable } from 'rxjs';
import { fadeInOut } from '../../../../assets/animations/animations';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { CompanyInfo } from '../../../interfaces/company-info';
import { ColorService } from '../../../services/color.service';
import { SEOService } from '../../../services/seo.service';

@UntilDestroy()
@Component({
  selector: 'app-verify-mail',
  templateUrl: './verify-mail.component.html',
  styleUrls: ['./verify-mail.component.scss'],
  animations: [fadeInOut],
  imports: [FloatingShapeComponent, TranslocoPipe],
})
export class VerifyMailComponent implements OnInit {
  private readonly colorService = inject(ColorService);
  private readonly jobboardAdapter = inject(JobboardAdapter);
  private readonly route = inject(ActivatedRoute);
  private readonly seoService = inject(SEOService);
  private readonly translateService = inject(TranslocoService);
  public readonly screenService = inject(ScreenService);

  @ViewChild('confettiTrigger') confettiTrigger: ElementRef;
  companyInformation$: Observable<CompanyInfo>;
  state: string;

  ngOnInit(): void {
    this.companyInformation$ = this.route.data.pipe(
      map((data: Data) => data['companyInfo'])
    );
    this.seoService.updateTitle(
      this.translateService.translate('jobboard.views.verify.title')
    );
    this.seoService.updateDescription('');

    this.companyInformation$.pipe(untilDestroyed(this)).subscribe({
      next: (companyInfo: CompanyInfo) => {
        this.colorService.setDesign(this.route.snapshot.params['companyId']);
        this.seoService.setWebsite(companyInfo.website);
      },
    });

    const nonce: string = this.route.snapshot.queryParams['id'];
    if (
      nonce &&
      nonce.match(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
      )
    ) {
      this.jobboardAdapter
        .verifyApplicantEmail(nonce)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.state = 'success';
            this.showConfetti();
          },
          error: () => {
            this.state = 'failed';
          },
        });
    } else {
      this.state = 'failed';
    }
  }

  showConfetti(): void {
    confetti({
      particleCount: 50,
      spread: 70,
      origin: { y: 0.6 },
    });
  }

  get correctedBackgroundColor(): string {
    if (this.colorService.background) {
      if (
        this.colorService.background.startsWith('rgb') &&
        !this.colorService.background.startsWith('rgba')
      ) {
        return (
          this.colorService.background.substring(
            0,
            this.colorService.background.length - 2
          ) + ', 0.133333)'
        );
      } else if (
        this.colorService.background.startsWith('#') &&
        this.colorService.background.length <= 7
      ) {
        return this.colorService.background + '22';
      } else {
        return this.colorService.background;
      }
    }
    return '';
  }
}
